import SaleDetail from 'components/productDetail/sale';
import Header from 'modules/header/farm/main';
import {useLocation} from 'react-router-dom';
import useGetPostDetail from '../hooks/useGetPostDetail';
import {useState} from 'react';
import CustomBottomSheet from 'components/bottomSheet';
import ViolationModal from 'modules/violationModal';
import {ViolationReportDetailItems} from 'pages/wholesaler/productDetail/constants';

const SaleDetailPage = () => {
  const [openViolationModal, setOpenViolationModal] = useState<boolean>(false);

  const location = useLocation();
  const {productDetail, isLoading} = useGetPostDetail(location.state.guid);
  const isFarm = location.pathname.includes('farm');
  return (
    <>
      {!isLoading && productDetail && (
        <>
          <Header title={productDetail.title} />
          <SaleDetail
            postGUID={location.state.guid}
            post={productDetail}
            app="farmer"
            setOpenViolationModal={setOpenViolationModal}
          />
          <CustomBottomSheet
            isOpen={openViolationModal}
            onDismiss={() => setOpenViolationModal(false)}
          >
            <ViolationModal
              open={openViolationModal}
              handleClose={() => setOpenViolationModal(false)}
              items={ViolationReportDetailItems}
              guid={location.state.guid}
              object_type="market"
              isFarm={isFarm}
            />
          </CustomBottomSheet>
        </>
      )}
    </>
  );
};

export default SaleDetailPage;
